import type { SavedFile } from 'mormaii-web-presentation'

/**
 * Salvar um arquivo no navegador: a metade de uma exportacao que depende do DOM.
 *
 * A apresentacao monta o arquivo (o CSV, o PDF) e entrega ao `FileSaver`; esta e a
 * funcao que o `main.tsx` instala nele. Antes de 08/10/2026 este codigo estava
 * repetido nos dois PDFs da apresentacao e no `downloadCsv` da view de Adocao e
 * Engajamento.
 */
export function saveInBrowser(file: SavedFile): void {
    const url = URL.createObjectURL(file.content)

    try {
        const link = document.createElement('a')
        link.href = url
        link.download = file.name
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
    } finally {
        // Sem isto o arquivo fica preso na memoria da aba ate ela fechar, e um
        // relatorio de cinco semanas nao e pequeno.
        URL.revokeObjectURL(url)
    }
}
